/* eslint-disable @typescript-eslint/no-explicit-any */
import { VStack, HStack, Grid, Skeleton, Box, GridItem } from '@chakra-ui/react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { MainTemplate } from '../../templates/MainTemplate';
import { Label } from '../../components/atoms/Label';
import { useTheme } from '../../contexts/ThemeProvider';
import { FaFrown } from 'react-icons/fa';
import { ExternalLink } from '../../components/atoms/ExternalLink';
import { useRevistasDigitaisInfinity } from '@/service/club/hooks';
import { Text } from '../../components/atoms/Text';

export function RevistasDigitaisPage() {
  const { colors, id } = useTheme();
  const { data, isFetching, isLoading, fetchNextPage, hasNextPage } = useRevistasDigitaisInfinity(id || 0, {
    limit: 28,
  });

  return (
    <MainTemplate>
      <VStack align={'self-start'} width="90%" marginBottom={'100px'} paddingTop={'20px'} spacing={6}>
        <HStack>
          <Label>Revistas Digitais</Label>
        </HStack>
        {!isFetching && !isLoading && (data?.pages[0]?.length === 0 || !data?.pages?.flat()?.length) && (
          <VStack margin={'auto'} spacing={5} paddingTop={'50px'}>
            <FaFrown size="50px" color={colors.primaryColor} />
            <Label>Você ainda não possui revistas digitais!</Label>
          </VStack>
        )}
        <InfiniteScroll
          dataLength={Number(data && data.pages ? data.pages.flat().length : 0)}
          next={fetchNextPage}
          hasMore={!!hasNextPage}
          scrollThreshold={0.5}
          loader={
            (isLoading || isFetching) && (
              <Grid
                width={'100%'}
                templateColumns={{
                  base: 'repeat(3, 1fr)',
                  md: 'repeat(4, 1fr)',
                }}
                gap={4}
              >
                {new Array(6).fill(0).map((_, i) => (
                  <Skeleton key={i} width={'100%'} borderRadius={'16px'} height="200px" />
                ))}
              </Grid>
            )
          }
        >
          <Grid
            templateColumns={{
              base: 'repeat(3, 1fr)',
              md: 'repeat(4, 1fr)',
            }}
            width="100%"
            gap={4}
          >
            {!isLoading &&
              (data?.pages?.flat()?.filter((m: any) => (m?.cover) && (m?.file_url || m?.pdf || m?.file || m?.link)) || [])
                .map((m: any) => {
                  const title = m?.article_title || m?.article_content || m?.title || m?.name || 'Revista';
                  const cover = m?.cover || m?.image || '';
                  const pdf = m?.file_url || m?.pdf || m?.file || m?.link || '';
                  const monthNames = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
                  const rawMonth = typeof m?.reference_month === 'number' ? m.reference_month : undefined;
                  const monthIndex = rawMonth && rawMonth >= 1 && rawMonth <= 12 ? rawMonth - 1 : rawMonth;
                  const monthLabel = typeof monthIndex === 'number' && monthIndex >= 0 && monthIndex <= 11 ? monthNames[monthIndex] : undefined;
                  const year = m?.reference_year;
                  const subtitle = monthLabel && year ? `${monthLabel}/${year}` : m?.agreement || '';
                  const issue = m?.issue_number ? `Edição ${m.issue_number}` : '';
                  return (
                    <GridItem key={m?.id || title}>
                      <ExternalLink to={pdf} display={'block'} textDecoration={'none'} _hover={{ textDecoration: 'none', color: 'inherit' }}>
                        <Box
                          bg="white"
                          borderRadius={'16px'}
                          boxShadow={'4px 4px 10px 0px #0000002E'}
                          overflow={'hidden'}
                        >
                        <Box position={'relative'} height={400} overflow={'hidden'} bg="#F1F4F5">
                          <Box
                            position={'absolute'}
                            top={0}
                            left={0}
                            right={0}
                            bottom={0}
                            style={{
                              backgroundImage: `url(${cover})`,
                              backgroundRepeat: 'no-repeat',
                              backgroundPosition: 'center',
                              backgroundSize: 'cover',
                              filter: 'blur(14px)',
                              transform: 'scale(1.1)',
                              opacity: 0.6,
                            }}
                          />
                          <Box
                            position={'relative'}
                            height={'100%'}
                            style={{
                              backgroundImage: `url(${cover})`,
                              backgroundRepeat: 'no-repeat',
                              backgroundPosition: 'center',
                              backgroundSize: 'contain',
                            }}
                          />
                        </Box>
                          <VStack align={'flex-start'} spacing={1} padding={3}>
                            <Text fontWeight={600} fontSize={16} color={'#292927'}>{title}</Text>
                            {(subtitle || issue) && (
                              <Text fontSize={12} color={'#747474'}>
                                {subtitle}
                                {subtitle && issue ? ' • ' : ''}
                                {issue}
                              </Text>
                            )}
                            {m?.agreement && !subtitle && (
                              <Text fontSize={12} color={'#747474'}>{m.agreement}</Text>
                            )}
                            {pdf && (
                              <Text color={colors.primaryColor} fontWeight={500}>
                                Abrir revista
                              </Text>
                            )}
                          </VStack>
                        </Box>
                      </ExternalLink>
                    </GridItem>
                  );
                })}
          </Grid>
        </InfiniteScroll>
      </VStack>
    </MainTemplate>
  );
}
